import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-industries',
  templateUrl: './industries.component.html',
  styleUrls: ['./industries.component.scss']
})
export class IndustriesComponent implements OnInit {

  constructor() { }


  ngOnInit(): void {
    this.scroll();
  }

  scroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  extensiveReach = [
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/education.png',
      title: 'Education'
    },
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/healthcare.png',
      title: 'Healthcare'
    },
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/ecommerce.png',
      title: 'Ecommerce'
    },
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/logistics.png',
      title: 'Logistics'
    },
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/iot.png',
      title: 'IoT'
    },
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/fintech.png',
      title: 'Fintech'
    },

    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/realEstate.png',
      title: 'Real estate'
    },
    //job platform
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/jobPlatform.png',
      title: 'Job Platforms'
    },
    //banking
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/banking.png',
      title: 'Banking'
    },
    //entertainment
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/entertainment.png',
      title: 'Entertainment'
    },
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/agritech.png',
      title: 'Agritech'
    },
    {
      bgImageUrl: '../../../../assets/images/patch/extensive-reach/retail.png',
      title: 'Retail'
    },
    //retail


  ]
  // extensiveReach = [
  //   {
  //     bgImageUrl: '../../../../assets/images/patch/automobile.png',
  //     title: ' Automobile & Transport'
  //   },
  //   {
  //     bgImageUrl: '../../../../assets/images/patch/finance.png',
  //     title: 'Finance & Fintech'
  //   },
  //   {
  //     bgImageUrl: '../../../../assets/images/patch/hospital.png',
  //     title: 'Hospitality & Real estate'
  //   },
  //   {
  //     bgImageUrl: '../../../../assets/images/patch/agritech.png',
  //     title: 'Agritech'
  //   },
  //   {
  //     bgImageUrl: '../../../../assets/images/patch/education.png',
  //     title: 'Education & Learning'
  //   },
  //   {
  //     bgImageUrl: '../../../../assets/images/patch/healthcare.png',
  //     title: 'Healthcare & Wellness'
  //   },
  // ]

}
